import {
  Box,
  Collapse,
  Link,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { lazy, useContext, useState } from "react";
import ArrowDownIcon from "src/components/ui/svgIcon/ArrowDownIcon";
import { HelpIcon } from "src/components/ui/svgIcon/HelpIcon";
import { MenuContext } from "src/contexts/menu-context/MenuContext";

const AquaticModalSection = (props) => {
  const theme = useTheme();
  const { menu, handleClose } = props;
  const { addToNewTab, setTab } = useContext(MenuContext);
  const educationLink = process.env.REACT_APP_EDUCATION_PAGE;

  function slugify(title) {
    return title.trim().replace(/\s+/g, "-");
  }

  const handleOpenPopup = (url, title) => {
    if (url) {
      const parts = url.split("/");
      const videoHash = parts.pop() || null;
      const slug = slugify(title);
      const FinalUrl = `${educationLink}/${videoHash}-${slug}`;
      window.open(FinalUrl, "_blank", "width=700,height=700,left=100,top=100,resizable=yes,scrollbars=yes");
    }
  };

  const handleMenuItemClick = (menuItem) => {
    if (menuItem.content) {
      addToNewTab(menuItem);
      setTab(menuItem.id);
    }
  };

  const [openSubMenu, setOpenSubMenu] = useState();

  const handleOpenSubMenu = (id) => {
    id === openSubMenu ? setOpenSubMenu(null) : setOpenSubMenu(id);
  };

  if (menu.menu.length !== 0)
    return (
      <>
        {menu?.menu.map((menuItem, index) => (
          <Box key={menuItem.node.id}>
            <MenuItem
              onClick={() => {
                handleOpenSubMenu(menuItem.node.id);
              }}
              className={menuItem.openCo ? "active" : ""}
              sx={{ fontWeight: "fontWeightMedium" }}
            >
              <Stack direction="row" justifyContent="space-between" width="100%" alignItems="center">
                <Box mr="auto">
                  <Typography variant="body2">{menuItem.node.menuName}</Typography>
                </Box>
                {menuItem.node.subMenus.edges.length !== 0 && (
                  <Box ml="auto">
                    {openSubMenu === menuItem.node.id ? (
                      <Stack flexDirection={"row"} gap={1}>
                        {menuItem.node.educationalGuidance && (
                          <Tooltip title="محتوای آموزشی" placement="bottom">
                            <Link
                              onClick={() => handleOpenPopup(menuItem.node.educationalGuidance, menuItem.node.menuName)}
                              rel="noopener noreferrer"
                              underline="hover"
                              sx={{ color: theme.palette.info.main, cursor: "pointer" }}
                            >
                              <HelpIcon fontSize="small" color={theme.palette.info.main} />
                            </Link>
                          </Tooltip>
                        )}
                        <ArrowDownIcon
                          fontSize="small"
                          sx={{ "& g": { stroke: (theme) => theme.palette.text.primary } }}
                        />
                      </Stack>
                    ) : (
                      <ArrowDownIcon
                        fontSize="small"
                        sx={{ transform: "rotate(90deg)", "& g": { stroke: (theme) => theme.palette.grey.g4 } }}
                      />
                    )}
                  </Box>
                )}
              </Stack>
            </MenuItem>
            <Collapse in={openSubMenu === menuItem.node.id} timeout="auto" unmountOnExit>
              <List
                component="div"
                disablePadding
                sx={{
                  borderRadius: 2,
                  border: `1px solid ${theme.palette.grey.g4}`,
                }}
              >
                {menuItem?.node?.subMenus?.edges.map((subMenuItem) => (
                  <ListItemButton
                    key={subMenuItem.node.id}
                    sx={{ pr: 4, textAlign: "left" }}
                    onClick={() => {
                      handleMenuItemClick({
                        val: subMenuItem.node.name,
                        id: subMenuItem.node.id,
                        loading: false,
                        content: subMenuItem.node.codeInWeb
                          ? lazy(() => import("src/features/" + subMenuItem.node.codeInWeb))
                          : null,
                        props: {
                          subMenuID: subMenuItem.node.id,
                          educationalGuidance: subMenuItem.node.educationalGuidance,
                        },
                      });
                      handleClose();
                    }}
                    disableRipple
                  >
                    <ListItemText
                      sx={{
                        ".MuiListItemText-primary": {
                          fontSize: 14,
                        },
                      }}
                      primary={subMenuItem.node.name}
                    />
                  </ListItemButton>
                ))}
              </List>
            </Collapse>
          </Box>
        ))}
      </>
    );
};

export default AquaticModalSection;
